import { combineReducers } from 'redux';


const INITIAL_STATE = {
    sougaku: '',
    haiguusha: 0,
    child: 2,
    KazeiIsangaku1: 0,
    KazeiIsangaku2: 0,
    KazeiIsangaku3: 0,
    isPaid: false,
    needEmailVerify: false,
    zlaboPremium: false
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CHANGE_SOUGAKU':
            return {...state, sougaku: action.sougaku }
        case 'CHANGE_HAIGUUSHA':
            return {...state, haiguusha: action.haiguusha }
        case 'CHANGE_CHILD':
            return {...state, child: action.child }
        case 'CHANGE_KAZEIISANGAKU1':
            return {...state, KazeiIsangaku1: action.KazeiIsangaku1 }
        case 'CHANGE_KAZEIISANGAKU2':
            return {...state, KazeiIsangaku2: action.KazeiIsangaku2 }
        case 'CHANGE_KAZEIISANGAKU3':
            return {...state, KazeiIsangaku3: action.KazeiIsangaku3 }
        case 'CHANGE_IS_PAID':
            return {...state, isPaid: action.isPaid }
        case 'SET_NEED_EMAIL_VERIFY':
            return {...state, needEmailVerify: action.needEmailVerify }
        case 'SET_ZLABO_PREMIUM':
            return {...state, zlaboPremium: action.zlaboPremium }
        default:
            return state;
    }
}

export const reducers = combineReducers({
    user: reducer
})